import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { format, parseISO } from 'date-fns';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

export default function ReelTypesList(props){
    //console.debug("RTS Break ReelTypesList");

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    function handleClick(e, cellValues){
        window.scrollTo(0,0);
        history("/ReelTypesEdit", {state:{idGuid:cellValues.row.idGuid, display:cellValues.row.name, mode:1}});
    }

    const columns = [
        {
            field: '',
            description:"Edit Reel Type", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'name', 
            headerName: "Reel Type", 
            description:"Reel Type Name", 
            flex:3,
            hideable:false
        },
        {
            field: 'idSap', 
            headerName: "SAP Id", 
            description:"Reel Type Id", 
            flex:2
        },        
        {
            field: 'material', 
            headerName: "Material", 
            description:"Reel Material", 
            flex:2,
        },
        {
            field: 'returnableFlag', 
            headerName: "Returnable", 
            description:"Returnable Reel Type",
            flex:2,    
            renderCell: (cellValues) => {
                if(cellValues.value === 0){
                    return ('No');
                }
                else{
                    return('Yes');
                }
            },     
        },         
        {
            field: 'activeReelCount', 
            headerName: "Active Reels", 
            description:"Count of Active Reels", 
            flex:2,
            type:'number',
        },        
        {
            field: 'activeLoadCount', 
            headerName: "Active Loads", 
            description:"Count of Active Loads", 
            flex:2,
            type:'number',
        }, 
        {
            field: 'flangeSize', 
            headerName: "Flange (in)", 
            description:"Flange Size (Inches)", 
            flex:2,
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        }, 
        {
            field: 'traverseSize', 
            headerName: "Traverse (in)", 
            description:"Traverse Size (Inches)", 
            flex:2,
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        }, 
        {
            field: 'drumSize', 
            headerName: "Drum (in)", 
            description:"Drum Size (Inches)", 
            flex:2,
            valueFormatter: (value, row) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        },                          
        {
            field: 'maxOverallWidth', 
            headerName: "Width (in)", 
            description:"Overall Width (Inches)", 
            flex:2,
            valueFormatter: (value) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        },
        {
            field: 'aborHoleSize', 
            headerName: "Arbor Hole (in)", 
            description:"Arbor Hole Size (Inches)", 
            flex:2,
            valueFormatter: (value) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        },                                   
        {
            field: 'weightCapacity', 
            headerName: "Capacity (lbs)", 
            description:"Weight Capacity (Pounds)", 
            flex:2,
            valueFormatter: (value) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
       },
        {
            field: 'approxWeight', 
            headerName: "Weight (lbs)", 
            description:"Reel Weight (Pounds)", 
            flex:2,
            valueFormatter: (value) => {
                if(value == null){
                    return '';
                }

                return (
                    value.toLocaleString(undefined, { maximumFractionDigits: 2 })   
                )
            },
            align:'right',
            type:'number',
        },
        {
            field: 'createUser', 
            headerName: "Create User", 
            description:"User who created reel", 
            flex:3,         
        },     
        {
            field: 'modifyDate', 
            headerName: "Modify Date", 
            description:"Last Modify Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
				if(value == null){
                    return null;
                }

                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },
        },
        {
            field: 'modifyUser', 
            headerName: "Modify User", 
            description:"User who performed last modification", 
            flex:3,         
        },          
    ];

    function getVisibilityModel(){
        if(smallForm){
            return {returnableFlag:false, material:false, activeReelCount:false, activeLoadCount:false, flangeSize:false, traverseSize:false, drumSize:false, maxOverallWidth:false, aborHoleSize:false, weightCapacity:false, approxWeight:false, createUser:false, modifyDate:false, modifyUser:false}
        }
        else{
            return {returnableFlag:false, flangeSize:false, traverseSize:false, drumSize:false, maxOverallWidth:false, aborHoleSize:false, weightCapacity:false, approxWeight:false, createUser:false, modifyDate:false, modifyUser:false}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
